module.exports = __webpack_public_path__ + "img/logoPie.92758522.jpg";